const termOptions = {
  entities: {
    title: 'Entities',
  },

  dictionary: {
    title: 'Dictionaries',
    search: 'Search in Dictionaries',
    create: 'Create Dictionary',
    iconClassName: 'dictionaries',
  },

  entity: {
    title: 'Entities',
    search: 'Search in Entities',
    create: 'Create Entity',
    iconClassName: 'entities',
  },

  context: {
    title: 'Contexts',
    search: 'Search in Contexts',
    create: 'Create Context',
    iconClassName: 'contexts',
  },

  rules: {
    title: 'Context Rules',
    search: 'Search in context rules',
    create: 'Create Context Rule',
    iconClassName: 'context-rules',
    buttonIconClassName: 'icon-add',
    reorder: {
      icons: {
        loaded: 'icon-reorder',
        start: 'icon-cw',
      },
      text: {
        loaded: 'Reorder context rules',
        start: 'Reordering...',
      },
    },
    group: {
      create: 'Rule Group',
      modalTitle: 'Create Rule Group',
    },
  },

  rule: {
    modal: {
      title: 'Create Rule',
      name: 'Rule',
      label: 'Rule Name',
      placeholder: 'Type Rule Name',
    },
  },

  group: {
    modal: {
      title: 'Create Rule Group',
      name: 'Group',
      label: 'Group Name',
      placeholder: 'Type Group Name',
    },
  },

  intent: {
    title: 'Intents',
    search: 'Search in Intents',
    create: 'Create Intent',
    iconClassName: 'intents',
  },

  resources: {
    title: 'Files',
    search: 'Search files',
    create: 'Upload files',
    iconClassName: 'resources',
    buttonClassName: 'icon-upload',
    placeholder: '/ Root',
  },

  flow: {
    title: 'Files',
    search: 'Search files',
    create: 'Upload files',
    iconClassName: 'test-set',
    buttonClassName: 'icon-upload',
    placeholder: '/ Root',
  },

  editor: {
    title: 'Text Editor',
    search: 'Search in file',
    iconClassName: 'test-set-editor',
  },

  testSetsEditor: {
    title: 'Test Sets',
    search: 'Search test sets',
    create: 'Upload files',
    iconClassName: 'test-set',
    buttonClassName: 'icon-upload',
    placeholder: '/ Root',
  },
};

export default termOptions;
